"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VariationSelector extends Marko.Component {
    constructor() {
        super(...arguments);
        this.traits = [];
        this.variations = {};
        this.possibleVarIntersection = [];
    }
    onCreate(input) {
        const { model } = input || {};
        this.traits = model && model.traits;
        this.variations = model && model.variations;
        this.selectedVariationId = input && input.selectedVariationId;
        this.possibleVarIntersection = Object.keys(this.variations) || [];
        this.state = {
            selectedTraits: {},
            error: false,
        };
    }
    onInput(input) {
        if (input && input.validate) {
            const isValid = !!this.selectedVariationId;
            this.state.error = !isValid;
            this.emit('validationResult', { isValid: isValid });
        }
    }
    onMount() {
        if (this.selectedVariationId &&
            !this.variations[this.selectedVariationId].outOfStock) {
            this.updateSelection();
            this.emitVariationSelectionEvent(); // Emit 'traitSelection' event as well if needed
        }
    }
    updateSelection() {
        if (!this.selectedVariationId)
            return;
        const selectedTraits = {};
        const variation = this.variations[this.selectedVariationId];
        if (variation) {
            for (const traitInVar in variation.traits) {
                if (traitInVar) {
                    const valueInVar = variation.traits[traitInVar];
                    const traitDetails = this.traits.find((trait) => trait.name === traitInVar);
                    const valueDetails = traitDetails &&
                        traitDetails.values.find((value) => value.name === valueInVar);
                    if (valueDetails) {
                        selectedTraits[traitInVar] = {
                            name: valueDetails.name,
                            possibleVariations: valueDetails.possibleVariations,
                        };
                    }
                }
            }
        }
        this.state.selectedTraits = selectedTraits;
    }
    handleTraitChange(selectedTrait) {
        const traitName = Object.keys(selectedTrait)[0];
        let noSelection = false;
        if (!selectedTrait[traitName]) {
            noSelection = true;
        }
        if (!noSelection) {
            this.emit('traitSelection', this.getTraitChangeEventData(selectedTrait));
            const selectedTraits = Object.assign({}, this.state.selectedTraits);
            selectedTraits[traitName] = {
                name: selectedTrait[traitName].name,
                possibleVariations: selectedTrait[traitName].possibleVariations,
            };
            this.state.selectedTraits = selectedTraits;
        }
        else {
            const selectedTraits = Object.assign({}, this.state.selectedTraits);
            delete selectedTraits[traitName];
            this.state.selectedTraits = selectedTraits;
            this.selectedVariationId = undefined;
        }
        this.updatePossibleVarIntersection(traitName);
        if (!noSelection &&
            Object.keys(this.state.selectedTraits).length === this.traits.length &&
            this.possibleVarIntersection.length === 1) {
            this.selectedVariationId = this.possibleVarIntersection[0];
            this.emitVariationSelectionEvent();
            this.state.error = false;
        }
    }
    emitVariationSelectionEvent() {
        if (this.selectedVariationId) {
            this.emit('variationSelection', this.getVariationData(this.selectedVariationId));
        }
    }
    getTraitChangeEventData(selectedTrait) {
        if (!selectedTrait) {
            return null;
        }
        const eventData = {
            trait: '',
            value: '',
        };
        const traitName = Object.keys(selectedTrait)[0];
        eventData.trait = traitName;
        eventData.value = selectedTrait[traitName].name || '';
        if (selectedTrait[traitName].images) {
            eventData.images = selectedTrait[traitName].images;
        }
        return eventData;
    }
    updatePossibleVarIntersection(traitName) {
        if (!traitName)
            return;
        if (Object.keys(this.state.selectedTraits).length === 0) {
            this.possibleVarIntersection = Object.keys(this.variations) || [];
            return;
        }
        const combinedPossibleVariations = Object.values(this.state.selectedTraits).map((item) => item.possibleVariations);
        this.possibleVarIntersection =
            combinedPossibleVariations.reduce((accumulator, currentArray) => accumulator &&
                accumulator.filter((value) => currentArray && currentArray.includes(value))) || [];
    }
    getVariationData(variationId) {
        if (!variationId) {
            return null;
        }
        const variationData = this.variations[variationId];
        if (!variationData) {
            return null;
        }
        return {
            variationId,
            price: variationData.price,
            quantity: variationData.quantity,
        };
    }
    getSelectedValue(traitName) {
        if (Object.keys(this.state.selectedTraits).length) {
            const selectedTrait = this.state.selectedTraits[traitName];
            return (selectedTrait && selectedTrait.name) || '-1';
        }
    }
}
exports.default = VariationSelector;
